import React from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useForm } from '../../../../../hooks/useForm';
import { makeStyles, IconButton } from '@material-ui/core';
import Title from './Title';
import SaveIcon from '@material-ui/icons/Save';
import { useDispatch, useSelector } from 'react-redux';
import {
  insertRecordatorio,
  updateRecordatorio,
} from '../../../../../actions/hce/hceActions';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    marginLeft: 'auto',
  },
}));

export const RecordatorioPropio = (props) => {
  const classes = useStyles();
  const { hce, disabled } = props;
  const dispatch = useDispatch();
  const { recordatorioP } = useSelector((state) => state.hce);

  const datosProtocolo = {
    recordatorio: recordatorioP[0]?.recordatorio || 'No hay Recordatorio',
  };

  const [formValues, handleInputChange] = useForm(datosProtocolo);

  const onSubmitHandler = () => {
    if (Array.isArray(recordatorioP) && recordatorioP.length === 0) {
      const data = {
        recordatorio: formValues.recordatorio,
        idAfiliado: hce.idAfiliado,
        idEfectorRed: hce.idEfector,
        esPropio: 1,
      };
      dispatch(insertRecordatorio(data));
      console.log('Ingreso', data);
    } else {
      const data = {
        id: recordatorioP[0].id,
        recordatorio: formValues.recordatorio,
        idEfectorRed: recordatorioP[0].idEfectorRed,
      };
      dispatch(updateRecordatorio(data));
      console.log('Update', data);
    }
  };

  return (
    <React.Fragment>
      <ValidatorForm onSubmit={onSubmitHandler}>
        <Title>
          Recordatorio Propio{' '}
          <div className={classes.buttonContainer}>
            {!disabled &&
              <IconButton color="primary" type="submit" disabled={disabled}>
                <SaveIcon />
              </IconButton>
            }
          </div>
        </Title>
        <TextValidator
          fullWidth
          variant="outlined"
          multiline
          rows={10}
          //label="Recordatorio"
          name="recordatorio"
          value={formValues.recordatorio}
          onChange={handleInputChange}
        //disabled={disabled}
        />
      </ValidatorForm>
    </React.Fragment>
  );
};
